import styles from './EmployedsProfileContent.module.scss';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';

export const getProblem = (worker: any, className = styles.status) => {
  if (
    (worker?.worker_app?.fns_status !== 1 && worker?.worker_app?.fns_status !== 2) ||
    worker?.worker_app?.app_status !== 3 ||
    worker?.is_deleted ||
    worker?.is_in_inn_stoplist
  )
    return (
      <span className={className} style={{ color: '#E10D0D', minWidth: 'fit-content' }}>
        <IconClose /> Не готов к сотрудничеству
      </span>
    );

  return (
    <span className={className} style={{ minWidth: 'fit-content' }}>
      <IconDone /> Готов к сотрудничеству
    </span>
  );
};
